/** @description Operator Name Constants */
export const operatorNames = {
    Empty: "~Empty",
    NotEmpty: "~NotEmpty",
    Equal: "~Equal",
    InList: "~InList",
    NotInList: "~NotInList",
    NotEqual: "~NotEqual",
    GreaterThan: "~GT",
    LessThan: "~LT",
    GreaterThanOrEqual: "~GTE",
    LessThanOrEqual: "~LTE",
    Today: "~Today",
    Overdue: "~Overdue",
    True: "~True",
    False: "~False",
    Text: "~Text",
    Range: "~Range",
};
